export default {
    1: "-0px -0px", // ARG
    2: "-64px -0px", // BOL
    3: "-32px -0px", // BRA
    4: "-96px -0px", // CHI
    5: "-160px -44px", // COL
    6: "-128px -0px", // CRC
    7: "-160px -0px", // CUB
    8: "-192px -0px", // ESA
    9: "-0px -22px", // ECU
    10: "-32px -22px", // GUA
    11: "-64px -22px", // HAI
    12: "-96px -22px", // HON
    13: "-128px -22px", // MEX
    0: "-192px -44px", // UNK
    14: "-160px -22px", // NCA
    15: "-192px -22px", // PAN
    16: "-0px -44px", // PAR
    17: "-32px -44px", // PER
    18: "-64px -44px", // DOM
    19: "-96px -44px", // URU
    20: "-128px -44px", // VEN
}

// 32x22

